export interface Cabinet {
  ref: string;
  name: string;
  idSociete: string;
}
export const cabinets: Cabinet[] = [
  { ref: "0998", name: "Foncia Saint Louis", idSociete: "01057" },
  { ref: "0995", name: "Foncia Mont Blanc", idSociete: "01041" },
  { ref: "0988", name: "Foncia Paris Est", idSociete: "00547" },
  { ref: "0986", name: "Foncia Loire Auvergne", idSociete: "00534" },
  { ref: "0973", name: "Foncia Marne La Vallée", idSociete: "00289" },
  { ref: "0950", name: "Foncia Loire Atlantique", idSociete: "00263" },
  { ref: "0945", name: "Foncia Property Management", idSociete: "00203" },
  { ref: "0922", name: "Foncia Breizh", idSociete: "00139" },
  { ref: "0919", name: "Foncia Normandie", idSociete: "00022" },
  { ref: "0918", name: "Foncia Val de Loire", idSociete: "00197" },
  { ref: "0812", name: "Foncia Grand Bleu", idSociete: "00173" },
  { ref: "0792", name: "Foncia Toulon", idSociete: "00163" },
  { ref: "0790", name: "Foncia Vendée", idSociete: "00167" },
  { ref: "0735", name: "Foncia Bouvet Bonnamour", idSociete: "01312" },
  { ref: "0733", name: "Foncia Cimes de Savoie", idSociete: "01134" },
  { ref: "0732", name: "Foncia Vallée", idSociete: "01148" },
  { ref: "0731", name: "Foncia Gresivaudan", idSociete: "01147" },
  { ref: "0730", name: "Foncia Mediterranee", idSociete: "01087" },
  { ref: "0729", name: "Foncia Des Lacs", idSociete: "01089" },
  { ref: "0728", name: "Foncia Agence Centrale 2 TTW", idSociete: "00113" },
  { ref: "0723", name: "Foncia Val de Vienne", idSociete: "00157" },
  { ref: "0709", name: "Foncia Armor", idSociete: "00156" },
  { ref: "0675", name: "Foncia Chadefaux Lecoq", idSociete: "00146" },
  { ref: "0674", name: "Foncia Mansart", idSociete: "00142" },
  { ref: "0653", name: "Foncia Roussillon Info Immobilier", idSociete: "00136" },
  { ref: "0635", name: "Foncia Terre Occitane", idSociete: "00130" },
  { ref: "0615", name: "Foncia Anjou-Maine", idSociete: "00129" },
  { ref: "0601", name: "Foncia Fabre Gibert", idSociete: "00122" },
  { ref: "0580", name: "Foncia AD Immobilier", idSociete: "00120" },
  { ref: "0563", name: "Foncia LCA", idSociete: "00117" },
  { ref: "0541", name: "Foncia Morbihan", idSociete: "00107" },
  { ref: "0532", name: "Foncia Alsace Bourgogne Franche Comté", idSociete: "00101" },
  { ref: "0471", name: "Foncia Loiret", idSociete: "00041" },
  { ref: "0427", name: "Foncia Immobilias Enseigne Commerciale Foncia Colbert", idSociete: "00057" },
  { ref: "0421", name: "Foncia Lyon", idSociete: "00080" },
  { ref: "0420", name: "Foncia Senart-Gatinais", idSociete: "00002" },
  { ref: "0417", name: "Foncia Marseille", idSociete: "00091" },
  { ref: "0416", name: "Foncia Vallée du Rhône", idSociete: "00074" },
  { ref: "0413", name: "Foncia Alpes Dauphiné", idSociete: "00082" },
  { ref: "0409", name: "Foncia Rives de Garonne", idSociete: "00094" },
  { ref: "0405", name: "Foncia Nice", idSociete: "00093" },
  { ref: "0399", name: "Foncia VBDS", idSociete: "00076" },
  { ref: "0394", name: "Foncia Val de Marne", idSociete: "00055" },
  { ref: "0385", name: "Foncia Pyrénées Gascogne", idSociete: "00011" },
  { ref: "0358", name: "Foncia Brette", idSociete: "00060" },
  { ref: "0321", name: "Foncia Bordeaux", idSociete: "00024" },
  { ref: "0290", name: "Foncia Toulouse", idSociete: "00037" },
  { ref: "0250", name: "Foncia Montpellier", idSociete: "00047" },
  { ref: "0233", name: "Foncia Terres de Provence", idSociete: "00017" },
  { ref: "0229", name: "Foncia Seine Ouest", idSociete: "00032" },
  { ref: "0222", name: "Foncia Paris Rive Droite", idSociete: "00025" },
  { ref: "0202", name: "Foncia Agence Centrale", idSociete: "00113" },
  { ref: "0140", name: "Foncia Paris Rive Gauche", idSociete: "00009" },
  { ref: "0087", name: "Gestion Immobiliere Privee - G.i.p Sas", idSociete: "01302" },
  { ref: "0075", name: "Foncia Lemanique", idSociete: "00004" },
  { ref: "0073", name: "Paris Syndic et Gestion", idSociete: "01300" },
  { ref: "0072", name: "Montagne et Seraphin Immobilier", idSociete: "01568" },
  { ref: "0062", name: "Agence Donibane", idSociete: "01486" },
  { ref: "0061", name: "Foncia Charente Maritime", idSociete: "00098" },
  { ref: "0054", name: "Cabinet Wurtz", idSociete: "01551" },
  { ref: "0049", name: "Foncia Hauts de France", idSociete: "00005" },
  { ref: "0046", name: "L'IDP", idSociete: "01464" },
  { ref: "0041", name: "Foncia AGDA", idSociete: "01198" },
  { ref: "0013", name: "Foncia LVM", idSociete: "00045" }  
  ] 
  
  export const CABINET_ACCESS_MAP: Record<string, string[]> = {
    //"0505": ["0061", "0728"],// to comment, just for locally testing
    "0417": ["0417", "0730"],
  };